import { addressArrayTransformer, addressArrayTransformerFashion, addressArrayTransformerGrahak } from './addressArrayTransformer';


export const addressTransformer = (response: AddressResponseType) => ({
  totalCount: response.total_count || 0,
  addresses: addressArrayTransformer(response.data || []),
});

export const addressTransformerFashion = (response: AddressResponseType) => ({
  // totalCount: response.total_count || 0,
  addresses: addressArrayTransformerFashion(response?.addresses || []),
});

export const addressTransformerGrahak = (response: AddressResponseType) => ({
  addresses: addressArrayTransformerGrahak(response || []),
});

export const addAddressFashionTransformer = (res:addAddressResponseType) => {
  let result = {
    success:false,
    customer_address_id: '',
  };

  if (res.status === 'success') {
    result.success = true,
    result.customer_address_id = res.response.addressId;
  }

  return result;
};

export const addAddressGrahakTransformer = (res:addAddressResponseType) => {
  let result = {
    success:false,
    customer_address_id: "",
  };

  if (res.status === "success") {
    result.success = true,
    result.customer_address_id = res?.data?.addressId || "";
  }

  return result;
};

export const editAddressTransformer = (response: EditAddressResponseType) => {
  let res = {
    success: false,
    message: '',
    customerAddressId: '',
  };
  if (response.status == 'success') {
    res.success = true;
    res.message = response.message;
    res.customerAddressId = response.response.customer_address_id;
  } else {
    res.success = false;
    res.message = response.message;
  }
  return res;
};

export const editAddressFashionTransFormer = (response:EditAddressFasionResponseType)=>{
   let res = {
      success:false,
      message:'',
      customerAddressId:'',
   };
   if (response.status === 'success') {
      res.success = true,
      res.message = '',
      res.customerAddressId = response.response.addressId;
   }
   return res;
};

export const editAddressGrahakTransFormer = (response:IEditAddressGrahakResponseType) => {
   let res = {
      success:false,
      message: "",
      customerAddressId: "",
   };
   if (response.status === "success") {
      res.success = true,
      res.message = "",
      res.customerAddressId = response?.data?.addressId || "";
   }
   return res;
};

